import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import ProfileSidebar from './ProfileSidebar';

/**
 * Layout component for profile routes (/profile/*)
 * Shows header + profile sidebar on the left + content area
 */
export const ProfileLayout: React.FC = () => {
  return (
    <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
      {/* Header */}
      <AppHeader />

      {/* Main layout with profile sidebar */}
      <div className="flex-1 flex overflow-hidden">
        {/* Profile Sidebar - Always visible in profile context */}
        <ProfileSidebar />

        {/* Main content */}
        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProfileLayout;
